import { createUseStyles } from 'react-jss';
import { base } from '../../../../styles';

export const overviewStyles = createUseStyles({
  container: {
    marginBottom: base(2),
  },
});
